'use strict';

class CalculateAllService {
    place_index = 0;
    place_count = 1;
    res_container = document.getElementById('finish-container');
    calculate(form) {
        $(form).on('beforeSubmit', (e) => {
            //e.preventDefault();
            ym(73234981, 'reachGoal', 'event_click_calculate');

            $(this.res_container).find('.empty_result').slideUp();
            $(this.res_container).removeClass('hidden');
            $(this.res_container).find('.service-list input[type=checkbox]').prop('checked', false);
            $(this.res_container).find('.loader-circle').fadeIn();

            let el = $('.scroll-result')[0];

            el.scrollIntoView({
                behavior: "smooth"
            });


            let url = '/calculate/result'
            let data = $(form).serializeArray();
            let callback = (result) => {
                this.pushResult(result);
            };
console.log(data);
            data.push({
                name: 'place_count',
                value: this.place_count
            })
            if (window.globalCalcRequest) {
                window.globalCalcRequest.abort();
                window.globalCalcRequest = new Ajax({
                    url: url,
                    data: data,
                    callback: callback,
                    error: function (data) {
                        console.log(data);
                    }
                })
            } else {
                window.globalCalcRequest = new Ajax({
                    url: url,
                    data: data,
                    callback: callback,
                    error: function (data) {
                        console.log(data);
                    }
                })
            }

            window.globalCalcRequest.ajaxRequest();

            return false;
        });
    }

    setPlacesIndexNumber() {
        $('.place-count').each(function (index, e) {
            $(e).html(index + 1);
        })
    }

    calculateVolume(fields) {
        let result = 1;

        fields.each(function (index, field) {
            result *= parseFloat($(field).val());
        });

        result = result / 1000000;

        if (result < 0.001) {
            result = 0.001;
        }

        return result;
    }

    calculateSize(volume) {
        let result = Math.pow(volume * 1000000, 1 / 3).toFixed();

        if (result < 1) {
            result = 1;
        }

        return result;
    }

    calculatePlacesWeightAndVolume() {
        let weight = 0
        let volume = 0;

        $('.place').each((index, e) => {
            weight += this._checkNumberIsNaN(parseFloat($(e).find('input[data-type="weight"]').val()));
            volume += this._checkNumberIsNaN(parseFloat($(e).find('input[data-type="volume"]').val()));
        })

        $('span.all-weight').text(weight.toFixed(2));
        $('span.all-volume').text(volume.toFixed(3));
    }

    _checkNumberIsNaN(number) {
        if (isNaN(number)) {
            return 0
        }

        return number;
    }

    pushResult(result) {
        if (result.status) {
            $(this.res_container).find('.loader-circle').fadeOut();
            $(this.res_container).find('.result').html(result.result);
            $(this.res_container).find('.result').slideDown();
            $(this.res_container).find('.place').removeClass('hidden');
            return;

        } else {
            $(this.res_container).find('.loader-circle').fadeOut();
            $(this.res_container).find('.empty_result').slideDown();
            Swal.fire({
                title: "Расчет недоступен!",
                heightAuto: false,
                text: "Воспользуйтесь формой обратной связи для получения стоимости расчета.",
                icon: "warning",
                buttons: ['Закрыть', 'Заказать расчет'],
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    $('#cod-wrong-callback').modal('show');
                } else {
                    swal.close();
                }
            });

            let city_out = $('#meacalcform-city_out_name').val(); //город отправления
            let city_in = $('#meacalcform-city_in_name').val(); //город назначения
            let address = $('#meacalcform-address_to').val();
            let price = $('#meacalcform-price').val();
            let declared_price = $('#meacalcform-declared_price').val();
            let val = $('.all-volume').html();
            let weight = $('.all-weight').html();

            let services = '';

            $('#places input:checkbox:checked').each(function () {
                services += $(this).closest('label').find('span').html() + "\n";
            });

            let calc_data = 'Город отправления: ' + city_out + "\n" +
                    'Город назначения: ' + city_in + "\n" +
                    'Адрес доставки: ' + address + "\n" +
                    'Стоимость товаров: ' + price + "\n" +
                    'Объявленная стоимость: ' + declared_price + "\n" +
                    'Общий объем: ' + val + "\n" +
                    'Общий вес: ' + weight + "\n" +
                    'Услуги:' + "\n" + services;

            $('#callbackwrongcalculate-calc_data').val(calc_data);
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = CalculateAllService;
}
